import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "AO_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#AO_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#1D1D1D"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "AO_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#AO_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v12h32V0H0z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.932 5.897l.427-1.405c3.2.977 5.13 2.69 5.672 5.132.36 1.62.197 3.069-.385 4.359-.415.919-.942 1.605-1.7 2.377-1.263 1.288-3.341 2.11-5.217 1.761a10.502 10.502 0 01-3.61-1.375l.766-1.252a9.037 9.037 0 003.11 1.183c1.355.252 2.962-.383 3.906-1.346.648-.66 1.08-1.223 1.41-1.954.453-1.004.58-2.129.29-3.434-.414-1.864-1.932-3.21-4.669-4.046z",
      fill: "#FFEA42"
    }
  ), /* @__PURE__ */ e.createElement(
    "g",
    {
      filter: "url(#AO_svg__filter0_d_4799_265823)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M9.846 9.464l-.95.657.335-1.101-.921-.696 1.156-.023.38-1.087.38 1.087 1.156.023-.922.696.335 1.101-.95-.657z",
        fill: "#FCFF01"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M9.846 9.464l-.95.657.335-1.101-.921-.696 1.156-.023.38-1.087.38 1.087 1.156.023-.922.696.335 1.101-.95-.657z",
        fill: "#FFEA42"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "g",
    {
      filter: "url(#AO_svg__filter1_d_4799_265823)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7.614 9.86s-1.684 2.468-.358 3.37c1.326.903 8.337 4.707 8.337 4.707s1.449-.008 1.655.3c.206.308.635.67.816.67.18 0 .647-.326.647-.326s.364-.298 0-.644c-.364-.346-2.287-1.532-2.287-1.532s-7.508-4.791-8.147-5.266c-.638-.474-.663-1.28-.663-1.28z",
        fill: "#FCFF01"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7.614 9.86s-1.684 2.468-.358 3.37c1.326.903 8.337 4.707 8.337 4.707s1.449-.008 1.655.3c.206.308.635.67.816.67.18 0 .647-.326.647-.326s.364-.298 0-.644c-.364-.346-2.287-1.532-2.287-1.532s-7.508-4.791-8.147-5.266c-.638-.474-.663-1.28-.663-1.28z",
        fill: "#FFEA42"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.712 4.074l-.39.883 1.279.553.362-.883-1.25-.553zm2.612 1.41l-.704.66.96 1.01.679-.672-.935-.998zm.962 2.653l.9-.349.493 1.276-.88.368-.513-1.295zm1.753 2.499l-.965-.03-.034 1.392.954.005.045-1.367zm-1.193 2.558l.883.39-.554 1.251-.883-.362.554-1.279zm-.524 3.008l-.66-.704-1.009.96.671.679.998-.935zm-2.645.965l.348.9-1.276.493-.368-.88 1.296-.513zm-2.493 1.754l.03-.964-1.392-.034-.006.954 1.367.044zM7.63 17.728l-.39.883-1.25-.553.362-.883 1.278.553z",
      fill: "#FFEA42"
    }
  ))),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
    "filter",
    {
      id: "AO_svg__filter0_d_4799_265823",
      x: 8.309,
      y: 7.214,
      width: 3.074,
      height: 2.907,
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB"
    },
    /* @__PURE__ */ e.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
    /* @__PURE__ */ e.createElement(
      "feColorMatrix",
      {
        in: "SourceAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }
    ),
    /* @__PURE__ */ e.createElement("feOffset", null),
    /* @__PURE__ */ e.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" }),
    /* @__PURE__ */ e.createElement(
      "feBlend",
      {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4799_265823"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "feBlend",
      {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_4799_265823",
        result: "shape"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "filter",
    {
      id: "AO_svg__filter1_d_4799_265823",
      x: 6.746,
      y: 9.859,
      width: 12.127,
      height: 9.048,
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB"
    },
    /* @__PURE__ */ e.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
    /* @__PURE__ */ e.createElement(
      "feColorMatrix",
      {
        in: "SourceAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }
    ),
    /* @__PURE__ */ e.createElement("feOffset", null),
    /* @__PURE__ */ e.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" }),
    /* @__PURE__ */ e.createElement(
      "feBlend",
      {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4799_265823"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "feBlend",
      {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_4799_265823",
        result: "shape"
      }
    )
  ))
);
export {
  t as default
};
